import React from 'react';
import Button from 'views/Button.js';
import { useServiceability } from 'views/ServiceabilityProvider.js';

// Single source of truth for "price vs. availability CTA" across the app.
//
// Wrap any price / add-to-cart region:
//   <PriceGate>{ ...normal price + Add to Cart... }</PriceGate>
//
//   online   -> renders children (normal commerce)
//   loading  -> a skeleton placeholder (pricing withheld until confirmed)
//   dealer   -> "Check availability" button (opens in-home consultation)
//   waitlist -> "Notify me when available" button (expansion capture)
//   error    -> "Check availability" (fail closed)
//
// `block` (default true) makes the CTA full-width; pass buttonStyle to tune it.
const PriceGate = ({ children, block = true, buttonStyle }) => {

    const { status, openAvailability } = useServiceability();

    if(status === 'online') {
        return children;
    }

    if(status === 'loading') {
        return (
            <div
                className={'skeleton'}
                style={{ height: 44, width: block ? '100%' : 168, borderRadius: 22, ...buttonStyle }} />
        );
    }

    // On error we can't confirm a dealer exists, so fall back to the notify
    // capture rather than promising an in-home consultation.
    const waitlist = status === 'waitlist' || status === 'error';
    return (
        // stop propagation so the CTA is safe inside click-through cards
        <span onClick={(e) => e.stopPropagation()} style={{ display: block ? 'block' : 'inline-block', width: block ? '100%' : 'auto' }}>
            <Button
                label={waitlist ? 'Join Waitlist' : 'Check availability'}
                type={'primary'}
                icon={waitlist ? 'fas fa-bell' : 'fas fa-map-marker-alt'}
                onClick={openAvailability}
                style={{ ...(block ? { width: '100%' } : {}), ...buttonStyle }} />
        </span>
    );
};

export default PriceGate;
